import React from "react";
import CommonButton from "../CommonButton";
import { ImagePath } from "../../assests";

interface AppleUIProps {
    onSuccess?: () => void;
    amount?: number;
}

const AppleUI: React.FC<AppleUIProps> = ({ onSuccess, amount }) => {
    return (
        <div className="flex flex-col gap-4 text-left animate-in fade-in duration-200">
            <div className="space-y-1">
                <h3 className="text-sm font-black text-slate-900 tracking-tight uppercase flex items-center gap-1.5">
                    <img
                        src={ImagePath.applePay}
                        alt="Apple Pay"
                        className="w-10 h-10 object-contain"
                    />
                    Apple Pay Instant Link
                </h3>

                <p className="text-xs text-slate-400 font-semibold leading-relaxed">
                    Authorize biometric clearance instantly using your stored Apple Wallet keychain credentials.
                </p>
            </div>

            {amount !== undefined && (
                <div className="bg-slate-50 border border-slate-200/60 rounded-xl p-3.5 flex justify-between items-center text-xs font-semibold">
                    <span className="text-slate-400 font-bold uppercase tracking-wider text-[10px]">
                        Total Checkout Authorization
                    </span>

                    <span className="text-sm font-mono font-black text-slate-900">
                        AED {amount.toFixed(2)}
                    </span>
                </div>
            )}

            <CommonButton
                text=" Pay with Apple Pay"
                variant="filled"
                className="w-full bg-slate-900 hover:bg-black text-white font-black text-xs h-11 shadow-xs transition"
                onClick={() => onSuccess && onSuccess()}
            />
        </div>
    );
};

export default AppleUI;